module.exports = __webpack_public_path__ + "static/media/OW3@2x.14da0418.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/OW/OW3@2x.png
// module id = 721
// module chunks = 0